import { FISH_ANIMATION_NAMES } from '../fishingCore/constants';

class FishingDrawerService {
  setFishSpine(fishSpine) {
    this.fishSpine = fishSpine;
  }

  setBgSpine(bgSpine) {
    this.bgSpine = bgSpine;
  }

  setSkeletonToSpine(spine, skeletonType) {
    spine.skeleton.setSkinByName(skeletonType);
  }

  resetSkeletonFromFishSpine() {
    this.fishSpine.skeleton.setSkin(null);
    this.fishSpine.skeleton.setSlotsToSetupPose();
  }

  playFishAnimation(skinName) {
    this.setSkeletonToSpine(this.fishSpine, `${skinName}`);
    this.fishSpine.play(FISH_ANIMATION_NAMES.Fish);
  }

  playBackGroundAnimation() {
    this.bgSpine.play(FISH_ANIMATION_NAMES.bgAnim, true);
  }

  playFishStaticAnimation() {
    this.fishSpine.play(FISH_ANIMATION_NAMES.Idle, true);
  }

  resetSpineState() {
    return this.fishSpine.state.clearTracks();
  }

  playSharkAnimation() {
    this.resetSkeletonFromFishSpine();
    this.setSkeletonToSpine(this.fishSpine, FISH_ANIMATION_NAMES.Shark);
    this.fishSpine.play(FISH_ANIMATION_NAMES.Shark, true);
  }
}

export const fishingDrawerService = new FishingDrawerService();
